import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PartInput } from './engine/rules';

export interface Job {
  id: string; created_at: string; updated_at: string;
  status: 'DRAFT'|'REVIEW'|'PLANNING'|'APPROVED'|'COMPLETE';
  customer: string; part_no: string; description: string;
  drawing_filename?: string;
  part?: PartInput;
  selected_machine?: string;
  template?: string;
  process_flow?: string[];
  engineer_notes?: string;
  approved_at?: string;
  parse_confidence?: number;
}

interface Store {
  jobs: Job[];
  addJob: (j: Omit<Job,'id'|'created_at'|'updated_at'>) => string;
  updateJob: (id: string, u: Partial<Job>) => void;
  deleteJob: (id: string) => void;
  getJob: (id: string) => Job | undefined;
}

export const useStore = create<Store>()(persist((set, get) => ({
  jobs: [],
  addJob: (j) => {
    const id = `JOB-${Date.now()}`;
    const now = new Date().toISOString();
    set(s => ({ jobs: [{ ...j, id, created_at: now, updated_at: now }, ...s.jobs] }));
    return id;
  },
  updateJob: (id, u) => set(s => ({
    jobs: s.jobs.map(j => j.id === id ? { ...j, ...u, updated_at: new Date().toISOString() } : j)
  })),
  deleteJob: (id) => set(s => ({ jobs: s.jobs.filter(j => j.id !== id) })),
  getJob: (id) => get().jobs.find(j => j.id === id),
}), { name: 'forgeiq-v2' }));
